<template>
    <div class="head-info flex align-items">
        <h3>{{ title }}</h3>
        <div class="global-operation">
            <!--返回按钮，放在最上面-->
            <template>
                <a-button v-if="back === true" @click="backFun"><i
                    class="iconfont iconquit"></i>返回
                </a-button>
            </template>


            <!--学员-->
            <template v-if="scenario === 'cstudentList'">
                <a-button v-if="check_limit('cstudent_save') && this.showOperate == '1'" type="primary" @click="optionFun('create')"><i
                    class="iconfont iconadd"></i>新增学员
                </a-button>
            </template>

            <!--班级-->
            <template v-if="scenario === 'classList'">
                <a-button v-if="check_limit('class_save') && this.showOperate == '1'" type="primary" @click="optionFun('create')"><i
                    class="iconfont iconadd"></i>新增班级
                </a-button>
            </template>

            <!--学生-->
            <template v-if="scenario === 'studentList'">
                <a-button v-if="check_limit('student_save') && this.showOperate == '1'" type="primary" @click="optionFun('create')"><i
                    class="iconfont iconadd"></i>新增学生
                </a-button>
            </template>

            <!--学院-->
            <template v-if="scenario === 'collegeList'">
                <a-button v-if="check_limit('college_save') && this.showOperate == '1'" type="primary" @click="optionFun('create')"><i
                    class="iconfont iconadd"></i>新增学院
                </a-button>
            </template>

            <!--学校-->
            <template v-if="scenario === 'schoolList'">
                <a-button v-if="check_limit('school_save') && this.showOperate == '1'" type="primary" @click="optionFun('create')"><i
                    class="iconfont iconadd"></i>新增学校
                </a-button>
            </template>

            <!--专业-->
            <template v-if="scenario === 'majorList'">
                <a-button v-if="check_limit('major_save') && this.showOperate == '1'" type="primary" @click="optionFun('create')"><i
                    class="iconfont iconadd"></i>新增专业
                </a-button>
            </template>

            <!--教室-->
            <template v-if="scenario === 'classroomList'">
                <a-button v-if="check_limit('classroom_save') && this.showOperate == '1'" type="primary" @click="optionFun('create')"><i
                    class="iconfont iconadd"></i>新增教室
                </a-button>
            </template>

            <!--老师-->
            <template v-if="scenario === 'teacherList'">
                <a-button v-if="check_limit('teacher_save') && this.showOperate == '1'" type="primary" @click="optionFun('create')"><i
                    class="iconfont iconadd"></i>新增老师
                </a-button>
            </template>

            <!--课程-->
            <template v-if="scenario === 'lchapterList'">
                <a-button v-if="check_limit('lchapter_save') && this.showOperate == '1'" type="primary" @click="optionFun('create')"><i
                    class="iconfont iconadd"></i>新增课程
                </a-button>
            </template>

            <!--课程模块-->
            <template v-if="scenario === 'lmoduleList'">
                <a-button v-if="check_limit('lmodule_save') && this.showOperate == '1'" type="primary" @click="optionFun('create')"><i
                    class="iconfont iconadd"></i>新增模块
                </a-button>
            </template>

            <!--课程库-->
            <template v-if="scenario === 'lessonList'">
                <a-button v-if="check_limit('lesson_save')" type="primary" @click="optionFun('create')"><i
                    class="iconfont iconadd"></i>新增课程库
                </a-button>
            </template>

            <!--简历拜访记录-->
            <template v-if="scenario === 'resumeVisitList'">
                <a-button v-if="check_limit('revisit_save') && this.showOperate == '1'" type="primary" @click="optionFun('create')"><i
                    class="iconfont iconadd"></i>新增拜访
                </a-button>
            </template>

            <!--简历-->
            <template v-if="scenario === 'resumeList'">
                <a-button v-if="check_limit('resume_save')" type="primary" @click="optionFun('create')"><i
                    class="iconfont iconadd"></i>新增简历
                </a-button>
            </template>

            <!--货物库存-->
            <template v-if="scenario === 'psiLogList'">
                <a-button v-if="check_limit('psilog_save')" type="primary" @click="optionFun('create')"><i
                    class="iconfont iconadd"></i>新增库存
                </a-button>
            </template>

            <!--货物-->
            <template v-if="scenario === 'psiList'">
                <a-button v-if="check_limit('psi_save')" type="primary" @click="optionFun('create')"><i
                    class="iconfont iconadd"></i>新增货物
                </a-button>
            </template>

            <!--工资-->
            <template v-if="scenario === 'sabillList'">
                <a-button v-if="check_limit('sabill_save')" type="primary" @click="optionFun('create')"><i
                    class="iconfont iconadd"></i>新增工资账单
                </a-button>
            </template>

            <!--员工管理-->
            <template v-if="scenario === 'employeeList'">
                <a-button v-if="check_limit('employee_save')" type="primary" @click="optionFun('create')"><i
                    class="iconfont iconadd"></i>新增员工
                </a-button>
                <a-button v-if="check_limit('employee_import')" type="primary" @click="optionFun('import')"><i
                    class="iconfont icontop_import"></i>导入员工
                </a-button>
            </template>
            <template v-if="scenario === 'employeeContract'">
                <a-button v-if="check_limit('employee_contract_save') && this.showOperate == '1'" type="primary" @click="optionFun('create')"><i
                    class="iconfont iconadd"></i>新增员工合同
                </a-button>
            </template>

            <!--职位管理-->
            <template v-if="scenario === 'jobList'">
                <a-button v-if="check_limit('job_save')" type="primary" @click="optionFun('create')"><i
                    class="iconfont iconadd"></i>新增职位
                </a-button>
            </template>

            <!--企业管理-->
            <template v-if="scenario === 'enterpriseList'">
                <a-button v-if="check_limit('enterprise_save')" type="primary" @click="optionFun('create')"><i
                    class="iconfont iconadd"></i>新增企业
                </a-button>
            </template>
            <template v-if="scenario === 'enterpriseContract'">
                <a-button v-if="check_limit('enterprise_contract_save') && this.showOperate == '1'" type="primary" @click="optionFun('create')"><i
                    class="iconfont iconadd"></i>新增企业合同
                </a-button>
            </template>

            <!--创建员工-->
            <template v-if="scenario === 'accountList'">
                <a-button v-if="check_limit('system_user_info')" type="primary" @click="optionFun('create')"><i
                    class="iconfont iconadd"></i>新增用户
                </a-button>
            </template>
            <!--创建部门-->
            <template v-else-if="scenario === 'roleList'">
                <a-button v-if="check_limit('system_role_info')" type="primary" @click="optionFun('create')"><i
                    class="iconfont iconadd"></i>新增部门
                </a-button>
            </template>
            <!--退出登录-->
            <template v-else-if="scenario === 'center'">
                <a href="javascript:void(0);" class="login-out flex align-items" @click="optionFun('logout')"><i
                    class="iconfont iconquit"></i>退出登录</a>
            </template>
            <template v-else-if="scenario === 'centerIndex'">
                最后更新时间：{{ timestamp }}
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        scenario: {
            type: [String],
            default: '',
        },
        timestamp: {
            type: String,
            default: '',
        },
        postData: {
            type: Object,
            default: () => {
            }
        },
        operate: {
            type: String,
            default: '1',
        },
        back: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        operate(val) {
            this.showOperate = val;
        },
    },
    data() {
        return {
            showOperate: this.operate, // 显示页面默认操作按钮
        };
    },
    components: {
    },
    methods: {
        // 操作
        optionFun(op) {
            this.$emit('optionFun', {scenario: this.scenario, op: op});
        },
        backFun() {
            this.$router.go(-1);
        }
    }
}
</script>
